export const MAIN_URL="https://inventory-nosfokxbxa-uc.a.run.app"
export const EMAIL_URL="automation/send-email/"